


















import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import { helpCenters, getServerList } from "@/req/gameManage";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";
const fontSizeStyle = Quill.import("attributors/style/size");
fontSizeStyle.whitelist = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
];
Quill.register(fontSizeStyle, true);
@Component({
  components: { headerTitle, quillEditor },
})
export default class Home extends Vue {
  public content = "";
  public disabled = true;
  public editorOption = {
    placeholder: "",
    modules: {
      toolbar: [
        ["bold"], // 加粗 斜体 下划线
        // ["bold", "italic", "underline"], // 加粗 斜体 下划线
        // [{ size: fontSizeStyle.whitelist }], // 字体大小
        // [{ color: [] }], // 字体颜色
      ],
    },
  };
  public mounted() {
    this.getList();
  }
  public async getList() {
    const res = await getServerList(
      "http://charge-api.996box.com/help.txt"
      // "http://charge-api-test.996box.com/help.txt"
    );
    this.content = res.data;
  }
  public edit() {
    this.disabled = false;
    // const input: any = this.$refs.myTextEditor;
    // this.$nextTick(() => {
    //     input.focus();
    //   });
  }
  public save() {
    this.disabled = true;
    this.saveHelp();
  }
  public async saveHelp() {
    const res = await helpCenters({
      data: this.content,
      type: "help",
    });
    if (res.code == 0) {
      this.$Message.success(res.msg);
      this.getList();
    }
  }
}
